<div [attr.id]="id" class="ignite-action-card">
  <div class="ignite-action-card-image">
    <img id="image_action" alt="" [src]="imageUrl" />
  </div>
  <div class="ignite-action-card-title">
    <ng-content select="[action-card-title]"></ng-content>
  </div>
  <div class="ignite-action-card-subtitle">
    <ng-content select="[action-card-subtitle]"></ng-content>
  </div>
  <div class="ignite-action-card-content">
    <ng-content select="[action-card-content]"></ng-content>
  </div>
  <div class="ignite-buttons-container">
    @for (act of actions; track act) {
      <div class="ignite-button-wrapper">
        @if (act.type === IgniteActionType.File) {
          <div>
            <button mat-button color="primary" class="ignite-button ignite-action-button" (click)="uploadFile.click()">{{ act.name }}</button>
            <input
              class="hidden"
              [id]="'ignite-action-card-action-' + act.name.replace(' ', '-')"
              [name]="'ignite-action-card-action-' + act.name.replace(' ', '-')"
              #uploadFile
              type="file"
              (change)="actionPerformed($event)"
              accept="image/*"
              />
            </div>
          }
          @if (act.type !== IgniteActionType.File) {
            <button
              [id]="'ignite-action-card-action-' + act.name.replace(' ', '-')"
              mat-button
              color="primary"
              class="ignite-button ignite-action-button"
              (click)="actionPerformed($event)"
              >
              @if (act.type === IgniteActionType.External) {
                <i class="fal fa-external-link-square"></i>
                }{{ act.name }}
              </button>
            }
          </div>
        }
      </div>
    </div>
